import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/information/question";

const informationQuestion = {
  create(param) {
    return http.spin.payload(`${BASE}/create`, param);
  },
  update(param) {
    return http.spin.payload(`${BASE}/update`, param);
  },
};

export default informationQuestion;
